import { r as o } from "./base-CwU3eNq--CZuQwsDV.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function d(i, c) {
  return (r, n, u) => {
    const s = (l) => {
      var e, t;
      return (t = (e = l.renderRoot) == null ? void 0 : e.querySelector(i)) != null ? t : null;
    };
    if (c) {
      const { get: l, set: e } = typeof n == "object" ? r : u != null ? u : (() => {
        const t = Symbol();
        return { get() {
          return this[t];
        }, set(h) {
          this[t] = h;
        } };
      })();
      return o(r, n, { get() {
        let t = l.call(this);
        return t === void 0 && (t = s(this), (t !== null || this.hasUpdated) && e.call(this, t)), t;
      } });
    }
    return o(r, n, { get() {
      return s(this);
    } });
  };
}
export {
  d as query
};
